// extracted by mini-css-extract-plugin
export default {"container":"send-sms-code_container__BP7PL","button":"send-sms-code_button__egRzE"};